/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SegmentsGetSegmentsSequenceQueryResponse, SegmentsGetSegmentsSequencePathParams, SegmentsGetSegmentsSequence400, SegmentsGetSegmentsSequence401, SegmentsGetSegmentsSequence403, SegmentsGetSegmentsSequence404 } from "../models/SegmentsGetSegmentsSequence";

export function getSegmentsGetSegmentsSequenceUrl(station: SegmentsGetSegmentsSequencePathParams["station"], timestamp: SegmentsGetSegmentsSequencePathParams["timestamp"]) {
  const res = { method: 'GET', url: `/segments/v1/stations/${station}/segments/sequence/${timestamp}` as const }
  return res
}

/**
 * @description Returns a bounded sequence of consecutive segments starting at the given timestamp (milliseconds since epoch), with basic fields only (id, startTs, endTs).
 * @summary Get a contiguous segments sequence from a timestamp
 * {@link /segments/v1/stations/:station/segments/sequence/:timestamp}
 */
export async function segmentsGetSegmentsSequence(station: SegmentsGetSegmentsSequencePathParams["station"], timestamp: SegmentsGetSegmentsSequencePathParams["timestamp"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SegmentsGetSegmentsSequenceQueryResponse, ResponseErrorConfig<SegmentsGetSegmentsSequence400 | SegmentsGetSegmentsSequence401 | SegmentsGetSegmentsSequence403 | SegmentsGetSegmentsSequence404>, unknown>({ method : "GET", url : getSegmentsGetSegmentsSequenceUrl(station, timestamp).url.toString(), ... requestConfig })
  return res.data
}